import { RootPaths } from "../App/paths";

export const CHATROOMS_PATH = "chatrooms";
export const CHATROOMS_FULL_PATH = `${RootPaths.APP_V2_HOME}/${CHATROOMS_PATH}`;
